import Swiper, { Navigation, FreeMode } from 'swiper';
import Component from '../Component';

class EventSlider extends Component {
  constructor(options) {
    super(options);
    this.slide = this.root.querySelectorAll('.swiper-slide');
    this.next = this.root.querySelector('.swiper_next');
    this.prev = this.root.querySelector('.swiper_prev');
  }

  removeSlides() {
    this.slide.forEach((slide) => {
      if (slide.classList.contains('multiple_dates')) {
        slide.parentNode.removeChild(slide);
      }
    });
  }

  attachEventListeners() {
    let setLoop = true;
    if (this.root.dataset.loop === 'false') {
      setLoop = false;
    }

    new Swiper(this.root, {
      modules: [Navigation, FreeMode],
      on: {
        beforeInit: () => {
          this.removeSlides();
        }
      },
      slidesPerView: 'auto',
      loop: setLoop,
      grabCursor: true,
      navigation: {
        nextEl: this.next,
        prevEl: this.prev
      },
      breakpoints: {
        768: {
          freeMode: {
            enabled: true
          },
        }
      }
    });
  }

  componentDidMount() {
    this.attachEventListeners();
  }
}

export default EventSlider;
